import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service'
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/_services/user/user.service';

@Component({
  selector: 'app-onboarding-form',
  templateUrl: './onboarding-form.component.html',
  styleUrls: ['./onboarding-form.component.scss']
})
export class OnboardingFormComponent implements OnInit {
  tenantId: string;
  usersForm;
  userCreationForm;
  isHRAdmin: boolean;
  isITAdmin: boolean;
  userDetails: any;
  requester: any;
  TodayDate: string;
  date: any;
  userCreationId: any;

  constructor( 
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private allocationService: AllocationService,
    private userService: UserService,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar) {
      this.usersForm = this.formBuilder.group({
        id: new FormControl({value:'' , disabled: true}),
        userId: new FormControl({value:'' , disabled: true}),
        password: new FormControl({value:'' , disabled: true}),
        firstName: new FormControl({value:'' , disabled: true}),
        middleName: new FormControl({value:'' , disabled: true}),
        lastName: new FormControl({value:'' , disabled: true}),
        displayName: new FormControl({value:'' , disabled: true}),
        department: new FormControl({value:'' , disabled: true}),
        phoneNo: new FormControl({value:'' , disabled: true}),
        location: new FormControl({value:'' , disabled: true}),
        joinDate: new FormControl({value:'' , disabled: true}),
        permanentOrContractor: new FormControl({value:'' , disabled: true}),
        alternateEmailId: new FormControl({value:'' , disabled: true}),
        supervisorId: new FormControl({value:'' , disabled: true}),
        supervisonName: new FormControl({value:'' , disabled: true}),
        currentDesignation: new FormControl({value:'' , disabled: true}),
        careerStartDate: new FormControl({value:'' , disabled: true}),
        managerId: new FormControl({value:'' , disabled: true}),
        managerName: new FormControl({value:'' , disabled: true}),
        biometric: new FormControl({value:'' , disabled: true}),
        totalExperience: new FormControl({value:'' , disabled: true}),
        currentExperience: new FormControl({value:'' , disabled: true}),
        localId: new FormControl({value:'' , disabled: true}),
        systemRequiredBoolean: new FormControl({value: '', disabled: true}),
        systemRequired: new FormControl({value:'', disabled: true}),
        emailIdRequired: new FormControl({value:'', disabled: true}),
        status: new FormControl({value:'', disabled: true}),
        birthDate: new FormControl({value:'', disabled: true}),
      })
      this.userCreationForm = this.formBuilder.group({
        id: new FormControl(''),
        requesterId: new FormControl({value:'' , disabled: true}),
        requesterName: new FormControl(''),
        requestedDate: new FormControl(''),
        status: new FormControl(''),
        userId: new FormControl({value:'' , disabled: true}),
        firstName: new FormControl(''),
        middleName: new FormControl(''),
        lastName: new FormControl(''),
        emailId: new FormControl(''),
        remarks: new FormControl(''),
        addedToBioMetrics: new FormControl(''),
        licenseType: new FormControl(''),
        licenseRequired: new FormControl(''),
        licenseAllocation: new FormControl(''),
        systemRequiredBoolean: new FormControl(''),
        systemRequired: new FormControl(''),
        ndaSignedDate: new FormControl(''),
        biometric: new FormControl(''),
        ismsTraining: new FormControl(''),
        ismsAgreement: new FormControl(''),
        emailIdRequired: new FormControl(''),
        ndaSignedBoolean: new FormControl(''),
        domainUserId: new FormControl('')
      });
     }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));

    this.requester = this.userDetails.id + " . " + this.userDetails.firstName + " " + this.userDetails.lastName;
    this.date = new Date();
    let latest_date = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.TodayDate = latest_date;

    this.userCreationForm.value.requesterId = this.requester;
    this.userCreationForm.value.requestedDate = this.TodayDate;
    this.userCreationForm.patchValue(this.userCreationForm.value);

    this.isHRAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleHrmAdministrator') ;
    this.isITAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleITAdministrator') ;

    this.userCreationId = this.route.snapshot.paramMap.get('id');
    console.log("userCreationId", this.userCreationId)
    if (this.userCreationId) {
      this.getUserCreationById(this.userCreationId);
    }
  }

  // getter for easy access to form fields
  get f() {
    return this.usersForm.controls;
  }

  getUserCreationById(id){
    this.userService.getUserCreationById(id).subscribe((response) => {
      console.log("response",response);
      if (response) {
        this.userCreationForm.patchValue({
          requesterId: response.requesterId + " . " + response.requesterName,
          requestedDate: response.requestedDate,
          userId: response.userId + " . " + response.firstName + " " + response.lastName,
          status: response.status,
          remarks: response.remarks,
          biometric: response.biometric,
        })
      }

      let systemRequiredValue = response.systemRequired;
      let systemRequiredBooleanValue = response.systemRequiredBoolean;
      let emailIdRequiredValue = response.emailIdRequired;
      let userId = response.userId;
      let status = response.status;
      this.userService.getUser(userId).subscribe((response) => {
        this.usersForm.patchValue({
          userId: response.userId,
          localId: response.localId,
          password: response.password,
          firstName: response.firstName,
          middleName: response.middleName,
          lastName: response.lastName,
          displayName: response.displayName,
          department: response.department,
          alternateEmailId: response.alternateEmailId,
          phoneNo: response.phoneNo,
          location: response.location,
          joinDate: response.joinDate,
          permanentOrContractor: response.permanentOrContractor,
          supervisonName: response.supervisorId + ' . ' + response.supervisonName,
          currentDesignation: response.currentDesignation,
          archived: true,
          managerName: response.managerName,
          systemRequiredBoolean: systemRequiredBooleanValue,
          systemRequired: systemRequiredValue,
          status: status,
          emailIdRequired: emailIdRequiredValue,
          birthDate: response.birthDate,
        });
        this.userCreationForm.value.emailId = response.emailId;
        this.userCreationForm.patchValue(this.userCreationForm.value);
      })
    })
  }

  backToOnboarding(){
    this.router.navigate([ this.tenantId + '/dashboard/itm/onboarding' ]);
  }

  openItonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-it', {id: this.userCreationId}]);
  }

  openHrmonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-form', {id: this.userCreationId}]);
  }

  openndaonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-nda', {id: this.userCreationId}]);
  }

}
